/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentProcessingStatus } from './DocumentProcessingStatus';
import {
    DocumentProcessingStatusFromJSON,
    DocumentProcessingStatusFromJSONTyped,
    DocumentProcessingStatusToJSON,
} from './DocumentProcessingStatus';
import type { ExternalEhrDocument } from './ExternalEhrDocument';
import {
    ExternalEhrDocumentFromJSON,
    ExternalEhrDocumentFromJSONTyped,
    ExternalEhrDocumentToJSON,
} from './ExternalEhrDocument';
import type { PdfConversionStatus } from './PdfConversionStatus';
import {
    PdfConversionStatusFromJSON,
    PdfConversionStatusFromJSONTyped,
    PdfConversionStatusToJSON,
} from './PdfConversionStatus';
import type { ScreenerDocumentError } from './ScreenerDocumentError';
import {
    ScreenerDocumentErrorFromJSON,
    ScreenerDocumentErrorFromJSONTyped,
    ScreenerDocumentErrorToJSON,
} from './ScreenerDocumentError';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    gcs_key?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    s3_access_url?: string;
    /**
     * 
     * @type {DocumentProcessingStatus}
     * @memberof Document
     */
    processing_status?: DocumentProcessingStatus;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    connector_document_id?: string;
    /**
     * 
     * @type {Array<ScreenerDocumentError>}
     * @memberof Document
     */
    errors?: Array<ScreenerDocumentError>;
    /**
     * Deprecated: use errors array with PROCESSING_ERROR type instead. Legacy field kept for backward compatibility.
     * @type {string}
     * @memberof Document
     * @deprecated
     */
    processing_error?: string;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    page_count?: number;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    filesize?: number;
    /**
     * 
     * @type {PdfConversionStatus}
     * @memberof Document
     */
    pdf_conversion_status?: PdfConversionStatus;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    orig_s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    orig_content_hash?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    content_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    has_been_analyzed?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Document
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    created_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    is_failed_ocr?: boolean;
    /**
     * 
     * @type {User}
     * @memberof Document
     */
    created_by_user?: User;
    /**
     * 
     * @type {ExternalEhrDocument}
     * @memberof Document
     */
    external_ehr_document?: ExternalEhrDocument;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    combined_from_lead_id?: string;
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'gcs_key': !exists(json, 'gcs_key') ? undefined : json['gcs_key'],
        's3_access_url': !exists(json, 's3_access_url') ? undefined : json['s3_access_url'],
        'processing_status': !exists(json, 'processing_status') ? undefined : DocumentProcessingStatusFromJSON(json['processing_status']),
        'connector_document_id': !exists(json, 'connector_document_id') ? undefined : json['connector_document_id'],
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(ScreenerDocumentErrorFromJSON)),
        'processing_error': !exists(json, 'processing_error') ? undefined : json['processing_error'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        'filesize': !exists(json, 'filesize') ? undefined : json['filesize'],
        'pdf_conversion_status': !exists(json, 'pdf_conversion_status') ? undefined : PdfConversionStatusFromJSON(json['pdf_conversion_status']),
        'orig_s3_key': !exists(json, 'orig_s3_key') ? undefined : json['orig_s3_key'],
        'orig_content_hash': !exists(json, 'orig_content_hash') ? undefined : json['orig_content_hash'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
        'has_been_analyzed': !exists(json, 'has_been_analyzed') ? undefined : json['has_been_analyzed'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'is_failed_ocr': !exists(json, 'is_failed_ocr') ? undefined : json['is_failed_ocr'],
        'created_by_user': !exists(json, 'created_by_user') ? undefined : UserFromJSON(json['created_by_user']),
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : ExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'combined_from_lead_id': !exists(json, 'combined_from_lead_id') ? undefined : json['combined_from_lead_id'],
    };
}

export function DocumentToJSON(value?: Document | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'gcs_key': value.gcs_key,
        's3_access_url': value.s3_access_url,
        'processing_status': DocumentProcessingStatusToJSON(value.processing_status),
        'connector_document_id': value.connector_document_id,
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(ScreenerDocumentErrorToJSON)),
        'processing_error': value.processing_error,
        'page_count': value.page_count,
        'filesize': value.filesize,
        'pdf_conversion_status': PdfConversionStatusToJSON(value.pdf_conversion_status),
        'orig_s3_key': value.orig_s3_key,
        'orig_content_hash': value.orig_content_hash,
        'content_type': value.content_type,
        'has_been_analyzed': value.has_been_analyzed,
        'metadata': value.metadata,
        'created_at': value.created_at,
        'is_failed_ocr': value.is_failed_ocr,
        'created_by_user': UserToJSON(value.created_by_user),
        'external_ehr_document': ExternalEhrDocumentToJSON(value.external_ehr_document),
        'combined_from_lead_id': value.combined_from_lead_id,
    };
}

